import { ActorRefFrom } from 'xstate';
import z from 'zod';
import { AppActorSystem } from '~/features/xstateSystem';
import { Address, JSONForm, JSONFormData, PeerReference } from '~/types';
import { AddressFormValues, optionSchema } from '../types';
import { Events } from './events';
import { peerRefMachine } from './peerReferenceMachine';

export type Context = {
  loading: boolean;
  peerReference: PeerReference;
  magicLink: undefined | string;
  formUi: object;
  form: object;
  defaultJSONFormData: undefined | JSONFormData;
  step: number;
  personalInfo: PeerRequestPersonalFormValues | undefined;
  notFound: boolean;
  address: AddressFormValues;
};

export interface Scope {
  context: Context;
  event: Events;
  system: AppActorSystem;
}

export const peerReferencePersonalSchema = z.object({
  emailAddress: z.email(),
  faxNum: z.string(),
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  occupation: z.string().optional(),
  phoneNum: z.string(),
  prefixName: z.string().optional(),
  relationshipType: optionSchema,
  shareFormFlag: z.boolean(),
  suffixName: z.string().optional(),
});

export type PeerRequestPersonalFormValues = z.infer<typeof peerReferencePersonalSchema>;

export interface PeerReferenceWithJSONFormResponse {
  peerReference: PeerReference;
  jsonForm: JSONForm;
  address: Address;
}

export interface WizardProps {
  actor: ActorRefFrom<typeof peerRefMachine>;
}
